import axios from 'lib/axios'

/**
 * @description service to get an specific betesa result by test id
 * @param testId: Number - id of the test
 */
const getBetesaResult = async (testId: number, userId?: number, userTestId?: number) => {
  const params = new URLSearchParams()
  if (userId) params.set('user_id', String(userId))
  if (userTestId) params.set('user_test_id', String(userTestId))
  const PATH = `${process.env.REACT_APP_MAIN_API}/betesa_result/resume/${testId}${params.toString() ? `?${params.toString()}` : ''}`
  try {
    const response = await axios.get(PATH)
    return response.data
  } catch (error) {
    console.error(error)
    return error
  }
}

export const getBetesaFollowUpSummaries = async (userId: number, processId: number) => {
  const PATH = `${process.env.REACT_APP_MAIN_API}/betesa_result/follow-ups/${userId}/${processId}`
  try {
    const response = await axios.get(PATH)
    return response.data
  } catch (error) {
    console.error(error)
    return { status: 'error', data: [] }
  }
}

const downloadBetesaComparison = async (path: string, userId: number, processId: number, userTestIds: number[]) => {
  const response = await axios.post(
    path,
    { user_id: userId, process_id: processId, user_test_ids: userTestIds },
    { responseType: 'arraybuffer' }
  )
  return response.data
}

export const downloadBetesaComparisonPdf = (userId: number, processId: number, userTestIds: number[]) =>
  downloadBetesaComparison('/reports/betesa/follow-up/comparison', userId, processId, userTestIds)

export const downloadBetesaFollowUpsExcel = (userId: number, processId: number, userTestIds: number[]) =>
  downloadBetesaComparison('/reports/betesa/follow-ups/excel', userId, processId, userTestIds)

export const downloadBetesaProcessFollowUpsExcel = async (processId: number) => {
  const response = await axios.post(
    '/reports/betesa/follow-ups/excel',
    { process_id: processId },
    { responseType: 'arraybuffer' }
  )
  return response.data
}

export default getBetesaResult
